// extracted by mini-css-extract-plugin
export default {"errorBoundaryWrapper":"ErrorBoundary_errorBoundaryWrapper__Oc3cf","reloadButton":"ErrorBoundary_reloadButton__uIQTi"};